import apiInstance from '../../../backend-api.setup'
import { ApiPathConfig } from '../../../../config/ApiPathConfig'

export const postForgotPasswordService = ({ email }: { email: string }) =>
  apiInstance.post(ApiPathConfig.FORGOT_PASSWORD, {
    email,
  })
